import React from "react"
import AlertContainer from "@/core/store/AlertContainer"
import { CommonDialog } from "./CommonDialog"

export const AlertModal: React.FC = () => {
  const { dialogState } = AlertContainer.useContainer()

  return <CommonDialog {...dialogState} />
}
